import {
  DataLoadingView,
  ThreeDotsLoaderAnimatedSvg,
} from "../../../components";
// import closeIconBlue from "../../../assets/icons/chevron-right-blue.png";
import { ITransactionIFrameViewProps } from "./TransactionIFrame";
import closeIcon from "../../../assets/icons/close-circle.svg";

export const View = ({
  closeIframe,
  iframeUrl,
  transactionIsProcessing,
}: ITransactionIFrameViewProps) => {
  return (
    <div className="transaction-iframe--container">
      <div className="flex-container justify-content--between align-items--center">
        <button
          className="close-iframe--button"
          onClick={closeIframe}
          title="close and try another payment provider"
          type="button"
        >
          <img
            src={closeIcon}
            alt="close page"
            className="close-iframe--icon"
          />
        </button>
        <h6 className="ml-5">Complete Your Payment</h6>
      </div>

      <div className="iframe-body flex-container red-border--show">
        {/* Show loader while loading the payment gateway checkout page */}
        {/* <div
          className="loading-switchapp-checkout"
          id="loading-checkout"
          style={{
            position: "absolute",
            height: "100%",
            width: "100%",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ThreeDotsLoaderAnimatedSvg fill="#000" />
        </div> */}

        {transactionIsProcessing ? (
          <div className="flex-container transaction-processing-view col justify-content--center align-items--stretch">
            {/* <DataLoadingView message="Transaction processing..." /> */}
            <DataLoadingView message="Please, Do not close this window. Checking transaction status..." />
          </div>
        ) : (
          <iframe
            id="complete-payment-iframe"
            src={iframeUrl}
            className="iframe--full-width"
            title="payment provider checkout"
            frameBorder="0"
            // width="700"
            // height="500"
            // style="overflow:hidden"
            // sandbox="allow-top-navigation allow-scripts allow-forms"
          ></iframe>
        )}
      </div>
    </div>
  );
};
